import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query. SSR-safe (returns `false` until mounted), then
 * tracks `matchMedia` changes. Use for the handful of places a layout genuinely
 * needs JS branching (e.g. bottom sheet on phones vs centered modal on desktop) —
 * prefer Tailwind responsive classes everywhere else.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && 'matchMedia' in window
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
